export default "__VITE_ASSET__CefakWiT__ 584w";